import { MailIcon } from './Icons';
import { ASSISTANT_AVATARS, type AiTeamMember } from '@/lib/assistant';

// Round initials avatar. The colour comes from a fixed set of six classes, picked per chat.

function initials(name: string): string {
  if (name.startsWith('+')) return '#';
  return name.split(/\s+/).map((w) => w.charAt(0)).join('').slice(0, 2).toUpperCase();
}

/** `email`: an envelope on the picture, so an email chat shows before it is opened (Gary, 19 Oct). */
export function Avatar({ name, colour, small = false, tiny = false, email = false }: { name: string; colour: number; small?: boolean; tiny?: boolean; email?: boolean }) {
  const size = tiny ? ' chats-avatar--tiny' : small ? ' chats-avatar--sm' : '';
  return (
    <span className={`chats-avatar chats-avatar--c${Math.abs(colour) % 6}${size}${email ? ' chats-avatar--email' : ''}`} aria-hidden="true">
      {initials(name)}
      {email && <span className="chats-avatar-mail"><MailIcon /></span>}
    </span>
  );
}

/** `tab`: the bottom-bar icon, a ring when idle and filled when its tab is open. `who`: whose picture (Ted, the Ask assistant, unless given). */
export function DrcAvatar({ large = false, tab = false, who = 'ted' }: { large?: boolean; tab?: boolean; who?: AiTeamMember }) {
  const size = large ? ' chats-drc-avatar--lg' : tab ? ' chats-drc-avatar--tab' : '';
  return <img src={`${import.meta.env.BASE_URL}${ASSISTANT_AVATARS[who]}`} alt="" className={`chats-drc-avatar${size}`} aria-hidden="true" />;
}

/** An AI team member's avatar (or the CMB Management channel's) where a chat shows round initials. */
export function TeamAvatar({ who, small = false, tiny = false }: { who: AiTeamMember | 'management'; small?: boolean; tiny?: boolean }) {
  const size = tiny ? ' chats-avatar--tiny' : small ? ' chats-avatar--sm' : '';
  return <img src={`${import.meta.env.BASE_URL}${ASSISTANT_AVATARS[who]}`} alt="" className={`chats-avatar chats-avatar--img${size}`} aria-hidden="true" />;
}
